


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ConfigCodeDialog from '@/components/ConfigCodeDialog/index.vue';
import ConflictPrompt from '@/components/ConflictPrompt/index.vue';
import InfoDialog from '@/components/InfoDialog/index.vue';
import ImageGallery from '@/components/ImageGallery/index.vue';
import Modal from '../Modal/index.vue';
import { Modal as IModal } from '../Modal/Modal.models';
import ModalWrapperAnimations from './ModalWrapper.animations';

@Component({
  components: {
    Modal,
    ConfigCodeDialog,
    ConflictPrompt,
    InfoDialog,
    ImageGallery
  },
  mixins: [ModalWrapperAnimations]
})
export default class ModalWrapper extends Vue {
  @Prop({ default: () => [] }) private modals!: IModal[];

  @Emit()
  private closeModal(modalId: number) {
    return modalId;
  }
}
